import { AssessmentReservationStatus, PageState, useAssignmentsContext } from "components/AssignmentsProvider";
import { InstanceRunningProvider } from "components/InstanceRunningContext/InstanceRunningContext";
import AssessmentInstancePage from "views/AssessmentInstancePage"
import AssignmentPage from "views/AssignmentPage"
import CongratulateAssessmentModal from "views/AssessmentInstancePage/components/CongratulateAssessmentModal"
import ErrorPage from "views/ErrorPage"
import ErrorAssignementPage from "views/ErrorAssignementPage"
import LoadingImage from "components/LoadingImage";
import { Suspense } from "react";

const LoadingFallback = () => {
  return (
    <div className="flex justify-center items-center min-h-[50vh] w-full">
      <div className="flex flex-col gap-4 items-center">
        <LoadingImage className="!h-[60px]" />
      </div>
    </div>
  )
}

const Assignment = () => {
  const { assessmentPageState, reservation }: any = useAssignmentsContext();

  return (
    <>

      {assessmentPageState === PageState.LOADING && (
        <LoadingFallback />
      )}
      {assessmentPageState === PageState.NOT_INVITED && (
        <ErrorAssignementPage errorType="not_found" />
      )}
      {(assessmentPageState === PageState.NOT_LOGGEDIN ||
        assessmentPageState === PageState.INVITED ||
        assessmentPageState === PageState.FAILED) && (
          <AssignmentPage />
        )}
      {(assessmentPageState === PageState.COMPLETED) && (
        <CongratulateAssessmentModal
          open={true}
          handleClose={() => { }}
        ></CongratulateAssessmentModal>
      )}
      {assessmentPageState === PageState.EXPIRED && (
        <ErrorAssignementPage errorType="expired" />
      )}
      {assessmentPageState === PageState.ERROR && (
        <ErrorPage />
      )}
      {assessmentPageState === PageState.INPROGRESS && (
        <>
          {(reservation && (
            (reservation.status === AssessmentReservationStatus.CREATED || reservation.status === AssessmentReservationStatus.SCHEDULED || reservation.status === AssessmentReservationStatus.PROVISIONING) ? (
              <AssignmentPage />
            ) : (
              <Suspense fallback={<LoadingFallback />}>
                <InstanceRunningProvider>
                  <AssessmentInstancePage />
                </InstanceRunningProvider>
              </Suspense>
            )
          ))}
          {(!reservation && (
            <AssignmentPage />
          ))}
        </>
      )}
    </>
  )
}

export default Assignment
